import * as React from 'react'
import Modal from '@mulesoft/anypoint-components/lib/Modal'
import ModalHeader from '@mulesoft/anypoint-components/lib/ModalHeader'
import ModalBody from '@mulesoft/anypoint-components/lib/ModalBody'
import ModalFooter from '@mulesoft/anypoint-components/lib/ModalFooter'
import Button from '@mulesoft/anypoint-components/lib/Button'
import TextField from '@mulesoft/anypoint-components/lib/TextField'
import Select from '@mulesoft/anypoint-components/lib/Select'
import Checkbox from '@mulesoft/anypoint-components/lib/Checkbox'
import './ExportCSVModal.css'

export type ValueProps = {
  opened: boolean,
  chartType: string
}

export type EventProps = {
  onClose: () => void
  onApply: (mode: string, dateTimeFormat: string, excel: boolean) => void
}

export type Props = ValueProps & EventProps

export type ModalProps = EventProps & {
  isGraph: boolean,
  headerText: string,
  cancelButtonText: string,
  confirmButtonText: string,
}

export type ModalState = {
  mode: string,
  dateTimeFormat: string,
  excel: boolean
}

export class ExportCSVModal extends React.Component<ModalProps, ModalState> {
  
  readonly modeOptions = [{label: 'Series as rows', value: 'rows'}, {label: 'Series as columns', value: 'columns'}]
  
  constructor(props: ModalProps) {
    super(props)

    this.state = {
      mode: 'rows',
      dateTimeFormat: 'YYYY-MM-DDTHH:mm:ssZ',
      excel: true
    }

    this.onSaveClick = this.onSaveClick.bind(this)
    this.onModeChange = this.onModeChange.bind(this)
    this.onDateTimeFormatChange = this.onDateTimeFormatChange.bind(this)
    this.onExcelDialectChange = this.onExcelDialectChange.bind(this)
  }

  onSaveClick() {
    const {mode, dateTimeFormat, excel} = this.state
    this.props.onApply(mode, dateTimeFormat, excel)
  }
  
  onModeChange(result: any) {
    this.setState({mode: result.value})
  }
  
  onDateTimeFormatChange(result: any) {
    this.setState({dateTimeFormat: result.value})
  }
  
  onExcelDialectChange(result: any) {
    this.setState({excel: result.value})
  }

  render() {
    const {mode, dateTimeFormat, excel} = this.state
    
    return (
      <Modal
        className={`export-csv-modal`}
        onClickOverlay={this.props.onClose}
        testId={`export-csv-modal`}
      >
        <ModalHeader className="export-csv-modal-header" testId={`export-csv-modal-header`} onClose={this.props.onClose}>
          <h1>{this.props.headerText}</h1>
        </ModalHeader>
        <ModalBody className="export-csv-modal-body" testId={`export-csv-modal-body`}>
          {this.props.isGraph &&
            <div className="export-csv-mode-selector">
              <span className="export-csv-mode-selector-text">Mode</span>
              <Select
                className="export-csv-select"
                testId="export-csv-select"
                options={this.modeOptions}
                value={mode}
                onChange={this.onModeChange}
              />
            </div>
          }
          {this.props.isGraph &&
            <div className="export-csv-date-format">
              <span className="export-csv-date-format-text">Date Time Format</span>
              <TextField
                className="export-csv-text-field"
                testId="export-csv-text-field"
                value={dateTimeFormat}
                onChange={this.onDateTimeFormatChange}
              />
            </div>
          }
          <div className="export-csv-excel">
            <span className="export-csv-excel-text">Excel CSV Dialect</span>
            <Checkbox
              className="export-csv-checkbox"
              testId="export-csv-checkbox"
              checked={excel}
              onChange={this.onExcelDialectChange}
            />
          </div>
        </ModalBody>
        <ModalFooter className="export-csv-modal-footer" testId={`export-csv-modal-footer`}>
          <Button
            className="export-csv-modal-cancel-button"
            testId={`export-csv-modal-cancel-button`}
            kind="tertiary"
            onClick={this.props.onClose}
            noFill={true}
          >
            {this.props.cancelButtonText}
          </Button>
          <Button
            className="export-csv-modal-confirm-button"
            testId={`export-csv-modal-confirm-button`}
            kind="primary"
            onClick={this.onSaveClick}
          >
            <div className="confirm-button-container">
              <div className="confirm-button-text">
                {this.props.confirmButtonText}
              </div>
            </div>
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export const DashboardExportCSVModal = (props: Props) => {
  const { opened, chartType, onClose, onApply } = props

  if (opened) {
    return (
      <ExportCSVModal
        headerText="Export CSV"
        cancelButtonText="Cancel"
        confirmButtonText="Export"
        isGraph={chartType === 'graph'}
        onClose={onClose}
        onApply={onApply}
      />
    );
  }
  return null;
}
